module.exports = __webpack_public_path__ + "img/paysafecard-alternative.1e60af26.png";